const hireDataUSA = {
    imageSrc: "images/home_side.jpg",
    title: "Empower Your Business with Ampstek’s Global Hiring Solutions, Anywhere You Need",
    description:
      "Expanding globally offers exciting opportunities, but navigating different employment laws can be complex.Rely on us to help you hire anyone, anywhere in the world, while ensuring full compliance.",
    className:'hireDataUSA'
  };
  const hiringsectionincompany = {
    imageSrc: "/images/home_side2.jpg",
    title: "Your Global Hiring Journey Starts Here – Let’s Connect!",
    description:
      "Expand your business globally with confidence. Schedule a consultation with our experts to learn how Ampstekpay can streamline international hiring and ensure compliance every step of the way.",
    className: 'hiringsectionincompany'
  };
  export { hireDataUSA, hiringsectionincompany};